export default __webpack_public_path__ + "static/media/BenefitsActiveIcon.b4f8e283.svg";